import GooglePayLimitInfo from 'features/moveMoney/screens/GooglePay/GooglePayLimitInfo';
import React from 'react';

export default function GooglePayLimitInfoPage() {
  return <GooglePayLimitInfo />;
}
